/**
 * Pizza Aperol — BUY1GET1 duo configurator (sections/ha-pizza-bundle-hero.liquid).
 * Picks 2 products (same product allowed twice), shows the total (cheapest one free)
 * and feeds the shared .bundle-add-to-cart button handled by assets/products-bundle.js.
 */
(function () {
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (e) {}
    }
    var value = (cents / 100).toFixed(2);
    var fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key.indexOf('comma') !== -1) return value.replace('.', ',');
      if (key.indexOf('no_decimals') !== -1) return String(Math.round(cents / 100));
      return value;
    });
  }

  function initHero(root) {
    var picker = root.querySelector('[data-pz-picker]');
    var dialog = picker ? picker.querySelector('[role="dialog"]') : null;
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-pz-slot]'));
    var atc = root.querySelector('[data-pz-atc]');
    var totalEl = root.querySelector('[data-pz-total]');
    var compareEl = root.querySelector('[data-pz-compare]');
    var hintEl = root.querySelector('[data-pz-hint]');
    var moneyFormat = root.getAttribute('data-money-format') || '';
    var selection = [null, null];
    var activeSlot = 0;
    var lastFocus = null;

    function openPicker(index) {
      activeSlot = index;
      lastFocus = document.activeElement;
      picker.hidden = false;
      document.body.classList.add('scrollHidden');
      if (dialog) dialog.focus();
    }

    function closePicker() {
      picker.hidden = true;
      document.body.classList.remove('scrollHidden');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function render() {
      slots.forEach(function (slot, i) {
        var empty = slot.querySelector('.pz-slot__empty');
        var filled = slot.querySelector('[data-pz-filled]');
        var card = slot.querySelector('[data-pz-card]');
        var item = selection[i];
        if (item) {
          card.innerHTML = item.html;
          card.querySelectorAll('a, button, input, select, [tabindex]').forEach(function (el) {
            el.setAttribute('tabindex', '-1');
          });
          empty.hidden = true;
          filled.hidden = false;
          slot.classList.add('pz-slot--filled');
        } else {
          card.innerHTML = '';
          empty.hidden = false;
          filled.hidden = true;
          slot.classList.remove('pz-slot--filled');
        }
      });

      var chosen = selection.filter(Boolean);
      if (chosen.length === 2) {
        var sum = chosen[0].price + chosen[1].price;
        var pay = Math.max(chosen[0].price, chosen[1].price);
        totalEl.textContent = formatMoney(pay, moneyFormat);
        compareEl.textContent = formatMoney(sum, moneyFormat);
        compareEl.hidden = sum <= pay;
        atc.disabled = !(chosen[0].available && chosen[1].available);
        atc.setAttribute(
          'data-bundle-products',
          JSON.stringify(
            chosen.map(function (c) {
              return {
                id: c.id,
                title: c.title,
                vendor: c.vendor,
                collection: c.collection,
                variant_sku: c.sku,
                price: c.price / 100,
              };
            }),
          ),
        );
        if (hintEl) hintEl.hidden = true;
      } else {
        if (chosen.length === 1) totalEl.textContent = formatMoney(chosen[0].price, moneyFormat);
        compareEl.hidden = true;
        atc.disabled = true;
        atc.setAttribute('data-bundle-products', '[]');
        if (hintEl) hintEl.hidden = false;
      }
    }

    function choose(option) {
      if (option.getAttribute('data-available') !== 'true') return;
      selection[activeSlot] = {
        id: parseInt(option.getAttribute('data-variant-id'), 10),
        price: parseInt(option.getAttribute('data-price'), 10) || 0,
        available: true,
        title: option.getAttribute('data-title'),
        vendor: option.getAttribute('data-vendor'),
        sku: option.getAttribute('data-sku'),
        collection: option.getAttribute('data-collection'),
        html: option.innerHTML,
      };
      closePicker();
      render();
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pz-open]');
      if (opener && root.contains(opener)) {
        e.preventDefault();
        openPicker(parseInt(opener.getAttribute('data-pz-open'), 10) || 0);
        return;
      }
      if (e.target.closest('[data-pz-close]')) {
        e.preventDefault();
        closePicker();
      }
    });

    // Capture phase: a click anywhere on a product card in the picker selects it
    // (instead of following the card link / quick add button).
    picker.addEventListener(
      'click',
      function (e) {
        var option = e.target.closest('[data-pz-option]');
        if (!option) return;
        e.preventDefault();
        e.stopPropagation();
        choose(option);
      },
      true,
    );

    picker.addEventListener('keydown', function (e) {
      var option = e.target.closest('[data-pz-option]');
      if (option && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        choose(option);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !picker.hidden) closePicker();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-pz-hero]').forEach(function (root) {
      if (root.__pzInit) return;
      root.__pzInit = true;
      initHero(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
